import { More, Trash, User} from "iconsax-react";
import { Dropdown, Modal, Spinner, Button, Row, Col } from "react-bootstrap";
import { useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import MyApiClient from "../../../../../api-client/MyApiClient";
import DEFAULT_STRUTTURA_NEW from "../../../../../images/DEFAULT_STRUTTURA_NEW.png";
import { TabellaListaServer } from "../../../../components/Tabella/TabellaListaServer";
import { ChipFilter } from "../../../../components/Tabella/ChipFilter";

// Valori del filtro Stato: quelli del profilo sul server, con le etichette della lista.
const STATO_OPTIONS = [
  { value: 'ACTIVE', label: 'Attivo' },
  { value: 'COMPLETED', label: 'Completato' },
  { value: 'INACTIVE', label: 'Inattivo' },
  { value: 'INVITED', label: 'Invitato' },
];

export const ListaStruttureSportive = () => {
  const navigate = useNavigate();

  const [data_json, setDataJson] = useState(null);
  // [] = Tutti (filtro con il chip «Tutti», 03/10/2026)
  const [statoFilter, setStatoFilter] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [totalItems, setTotalItems] = useState(null);
  const fetchIdRef = useRef(0);

  const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');


	const [loadingShowed, setLoadingShowed] = useState(false);

  const fetchData = useCallback(async ({ pageIndex, pageSize, globalFilter, sortBy, filters, externalFilters }) => {
    const fetchId = ++fetchIdRef.current;
    setLoadingShowed(true);

    try {
      const tokenDetailsString = sessionStorage.getItem('userDetails');
      if (tokenDetailsString) {
        const tokenDetails = JSON.parse(tokenDetailsString);
        let token = tokenDetails.idToken;
        const apiClient = new MyApiClient();

        const offset = pageIndex * pageSize;
        const limit = pageSize;
        const searchName = globalFilter || null;

        let sort = null;
        let sortAscending = true;
        
        if (sortBy && sortBy.length > 0) {
            const sortId = sortBy[0].id;
            sortAscending = !sortBy[0].desc;
            
            switch (sortId) {
                case 'name':
                    sort = 'NAME';
                    break;
                case 'status':
                    sort = 'PROFILE_STATUS';
                    break;
                case 'nr-clienti':
                    sort = 'CLIENTS';
                    break;
                case 'nr-soci':
                    sort = 'MEMBERS';
                    break;
                case 'nr-maestri':
                    sort = 'COACHES';
                    break;
                case 'email':
                    sort = 'EMAIL';
                    break;
                case 'createdAt':
                    sort = 'CREATED_AT';
                    break;
                default:
                    sort = 'CREATED_AT';
                    break;
            }
        }
        
        let filterName = null;
        let filterEmail = null;
        
        if (filters && filters.length > 0) {
            filters.forEach(filter => {
                if (filter.id === 'name') {
                    filterName = filter.value;
                } else if (filter.id === 'email') {
                    filterEmail = filter.value;
                }
            });
        }

        const stato = externalFilters?.stato;
        const profileStatus = Array.isArray(stato) ? (stato.length ? stato : null) : (stato || null);
        const membershipData = await apiClient.getProfilesByFilters(token, limit, searchName, 'CLUB', offset, sort, sortAscending, filterName, filterEmail, profileStatus);

        if (fetchId === fetchIdRef.current) {
           setLoadingShowed(false);
           if(membershipData) {
             let data_member = [];
             if (membershipData.items) {
                membershipData.items.forEach(element => {

                  let image = null;
                  if(element.logo) {
                    image = element.logo;
                  }

                  let status = null;
                  if(element.profileStatus==='INACTIVE') {
                    status = {
                      "label": "Inattivo",
                      "class": "text-danger"
                    };
                  } else if(element.profileStatus==='ACTIVE') {
                    status = {
                      "label": "Attivo",
                      "class": "text-success"
                    };
                  } else if(element.profileStatus==='COMPLETED') {
                    status = {
                      "label": "Completato",
                      "class": "text-success"
                    };
                  } else if(element.profileStatus==='INVITED') {
                    status = { "label": "Invitato", "class": "text-warning" };
                  } else {
                    // Stato mancante o nuovo: si mostra com'è invece di rompere tutta la lista.
                    status = { "label": element.profileStatus || "—", "class": "" };
                  }

                  let member_row = {
                    "id": element.userId,
                    "name": element.name,
                    "imageUrl": image,
                    "status": status,
                    "nr-clienti": element.clients,
                    "nr-soci": element.members,
                    "nr-maestri": element.coaches,
                    "email": element.email,
                    "phoneNumber": element.phoneNumber,
                    "createdAt": element.createdAt
                  };
                  data_member.push(member_row);

                });
             }
             
             setDataJson(data_member);
             
             // Calculate pageCount
             const totalItems = membershipData.numberOfItems || membershipData.total || membershipData.count || membershipData.totalCount || 0;
             // Senza totale dal server il numero non si conosce: meglio non mostrarlo che mostrarlo sbagliato.
             setTotalItems(totalItems > 0 || data_member.length === 0 ? totalItems : null);
             
             if (totalItems > 0) {
                setPageCount(Math.ceil(totalItems / pageSize));
             } else {
                 // Fallback if total is not returned:
                 // If the number of items returned matches the page size, assume there is at least one more page.
                 if (membershipData.items && membershipData.items.length === pageSize) {
                     setPageCount(pageIndex + 2);
                 } else {
                     setPageCount(pageIndex + 1);
                 }
             }
           }
        }
      }
    } catch (error) {
        if (fetchId === fetchIdRef.current) {
            setLoadingShowed(false);
            console.error("Error fetching data:", error);
        }
    }
  }, []);

  // Ordine deciso il 03/10/2026: data, nome, player, soci, maestri, stato.
  const data_column = [
    {
      Header: 'Data registrazione',
      Footer: 'Data registrazione',
      accessor: 'createdAt',
      disableFilters: true,
      Cell: ({ value }) => {
        if (!value) return '-';
        return new Date(value).toLocaleDateString('it-IT', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      },
    },,
    {
      Header: 'Ragione sociale',
      Footer: 'Ragione sociale',
      accessor: 'name',
      Cell: ({ row }) => (
				<div style={{ display: 'flex', alignItems: 'center' }}>
				  <img
					src={row.original.imageUrl ? row.original.imageUrl : DEFAULT_STRUTTURA_NEW}
					alt={row.original.name}
					style={{
					  width: '40px',
					  height: '40px',
					  borderRadius: '50%',
					  marginRight: '10px',
					  objectFit: 'cover',
					  backgroundColor: '#fff'
					}}
				  />
				  {row.original.name}
				</div>
			)
    },,
    {
      Header: 'Nr Player',
      Footer: 'Nr Player',
      accessor: 'nr-clienti',
      disableFilters: true,
    },,
    {
      Header: 'Nr Soci',
      Footer: 'Nr Soci',
      accessor: 'nr-soci',
      disableFilters: true,
    },,
    {
      Header: 'Nr Maestri',
      Footer: 'Nr Maestri',
      accessor: 'nr-maestri',
      disableFilters: true,
    },,
    {
      Header: 'Stato',
      Footer: 'Stato',
      id: 'status',
      accessor: row => row.status?.label || '',
      Cell: ({ row }) => {
          const { class: cls, label } = row.original.status || {};
          return (
              <div className="d-flex align-items-center">
                  <i className={`fa fa-circle me-1 ${cls}`} />
                  {label}
              </div>
          );
      },
      disableFilters: true,
    },
  ];

  function openDetail(row) {
		navigate('/superadmin/anagrafiche/strutture-sportive/'+row.id);
	}

  return (
    <>
      <Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={modalShowed} centered>
        <Modal.Header>
          <Modal.Title>{modalTitle}</Modal.Title>
          <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Row><Col className="col-xl-64">{modalText}</Col></Row>
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
            Chiudi
          </Button>
        </Modal.Footer>
      </Modal>

      <TabellaListaServer
        openColumn={'name'}
        openRow={(row) => openDetail(row)}
        cardTitle={'Strutture sportive'}
        sidLayout={true}
        pageList={true}
        hasSearch={true}
        searchPlaceholder={'Cerca per ragione sociale o email'}
        hasFilter={false}
        filterControl={
          <div className="sid-chip-filters">
            <ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} withAll />
          </div>
        }
        externalFilters={{ stato: statoFilter }}
        hasAddMore={false}
        data_column={data_column}
        data_json={data_json}
        manualPagination={true}
        pageCount={pageCount}
        totalItems={totalItems}
        fetchData={fetchData}
        sort_by={'createdAt'}
        sort_type={'desc'}
        manualGlobalFilter={true}
        manualFilters={true}
      />
    </>
  )
}
export default ListaStruttureSportive;